//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.FeatureParmsBuilder.js";
import "../no/Section.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/RegionPointList.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../Features/Features.ShipDesign.PlateStockBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
import "../no/Weld.js";
let d=[[[0,"BoundaryPlane",1,"Plane",0],[1,"BoundarySection",0,"Section",0],[1,"BoundarySheets",0,"SelectNXObjectList",0],[1,"Offset",0,"Expression",0],[0,"Primary",1,0],[0,"PrimaryOnReference",1,0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"RegionOption",1,0],[1,"Regions",0,"RegionPointList",0],[0,"Secondary1",1,0],[0,"Secondary1OnReference",1,0],[0,"Secondary2",1,0],[0,"Secondary2OnReference",1,0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"SplitKnuckleEdges",0,"SelectNXObjectList",0],[1,"Stock",0,"Features.ShipDesign.PlateStockBuilder",0],[0,"ThicknessDirection",0,"Features.ShipDesign.ThicknessDirectionBuilder",0],[0,"Tightness",1,0],[0,"Weld",0,"Weld.CharacteristicsBuilder",0]],[[["regionPoints"],"SetRegionPoints",{},1,0],[[],"CreateRegionBody",{R_:{regionBody:"Body"}},0,0],[[],"DeleteRegionBody",{},0,0],[["knuckle_edges"],"SetKnuckleEdges",{},1,0],[["isSplitEdgeUpdate"],"SetSplitEdgeUpdateFlag",{},1,0],[[],"CleanUpTemporaryCurves",{},0,0],[["indexArray"],"SetRegionIndex",{},1,0],[["bDelete"],"DeletePreviewBody",{},1,0],[["bPreview"],"SetPreviewOption",{},1,0],[["extend_boundaries"],"SetExtendBoundary",{},1,0],[["bExtendCurveBoundary"],"SetExtendCurveBoundary",{},1,0],[["boundaryObject"],"RemoveObjectBoundary",{},1,0],[["boundaryCurve"],"RemoveCurveBoundary",{},1,0]],[]];
SPLM.Features.ShipDesign.PlateSystemBuilder = class extends SPLM.Features.ShipDesign.FeatureParmsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PlateSystemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PlateSystemBuilder.StiffenerDirectionType = Object.freeze({
    "FwdPortToInUp" : "FwdPortToInUp", "AftStbdFrOutDn" : "AftStbdFrOutDn", "FwdPortToInCtr" : "FwdPortToInCtr", "AftStbdFrOutCtr" : "AftStbdFrOutCtr"});

SPLM.Features.ShipDesign.PlateSystemBuilder.RegionOptions = Object.freeze({
    "All" : "All", "InsideBody" : "InsideBody", "OutsideBody" : "OutsideBody"});

export default SPLM;